import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { TemplateResult } from 'src/app/models/template-result.model';
import { ITemplateFilter, Template } from 'src/app/models/template.model';
import { TemplateService } from 'src/app/services/template/template.service';


@Component({
  selector: 'gabarito-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {

  title;
  dates: Date[];
  showFilterEmpty = false;
  isFiltering = false;
  loading = false;
  faSpinner = faSpinner;

  filteredTitle: string;

  filteredBeginAt: Date;
  filteredEndAt: Date;
  filterSelected: any;

  @Input() isEnabled: boolean;

  @Output() templates: EventEmitter<TemplateResult> = new EventEmitter<TemplateResult>();
  @Output() filters: EventEmitter<ITemplateFilter> = new EventEmitter<ITemplateFilter>();

  constructor(private service: TemplateService) { }

  ngOnInit() {
  }


  filter() {
    if (this.title || this.dates) {
      this.isFiltering = true;
      this.filteredTitle = this.title;
      if (this.dates) {
        if (this.dates[0]) {
          this.dates[0].setHours(0);
          this.dates[0].setMinutes(0);
        }

        if (this.dates[1]) {
          this.dates[1].setHours(23);
          this.dates[1].setMinutes(59);
          this.dates[1].setSeconds(59);
        }

        this.filteredBeginAt = this.dates[0];
        this.filteredEndAt = this.dates[1];
      }
      this.loading = true;
      this.filterSelected = { title: this.title ? this.title : '',
                              transmissionBeginAt: this.dates ? moment(this.dates[0]).format('YYYY-MM-DD HH:mm:ss') : '',
                              transmissionEndAt: this.dates && this.dates[1] ?
                              moment(this.dates[1]).format('YYYY-MM-DD HH:mm:ss') : ''};
      this.service.searchTemplate(this.filterSelected, this.isEnabled)
                                    .subscribe(
                                      response => {
                                        if (response) {
                                          this.loading = false;
                                          this.showFilterEmpty = false;
                                          response.data.sort(Template.sortTemplateTitle);
                                          this.templates.emit(response);
                                        }
                                      },
                                      error => {
                                        if (error.status === 404) {
                                          this.showFilterEmpty = true;
                                          this.loading = false;
                                          this.filterSelected = {};
                                          this.filters.emit(this.filterSelected);
                                        }
                                      }
                                    );
    } else {
      this.filterSelected = null;
      this.isFiltering = false;
      this.filteredBeginAt = null;
      this.filteredEndAt = null;
      this.filteredTitle = null;

      this.service.findAllPaginate(this.isEnabled).subscribe(
        response => {
          if (response) {
            this.showFilterEmpty = false;
            this.loading = false;
            this.templates.emit(response);
          }
        }
      );
    }
    this.filters.emit(this.filterSelected);
  }

  clear() {
    this.title = null;
    this.dates = null;
    this.filterSelected = null;
    this.isFiltering = false;
    this.filteredBeginAt = null;
    this.filteredEndAt = null;
    this.filteredTitle = null;

    this.service.findAllPaginate(this.isEnabled).subscribe(
      response => {
        if (response) {
          this.showFilterEmpty = false;
          response.data.sort(Template.sortTemplateTitle);
          this.templates.emit(response);
        }
      }
    );
  }
}
